const translations = {
  "en": {
    "/ month": "/ month",
    "/ year": "/ year",
    "≈$40k sitting idle → a 4.5% position.": "≈$40k sitting idle → a 4.5% position.",
    "$31,000 less lost in a 2022-style drop": "$31,000 less lost in a 2022-style drop",
    "$34k more in 15 years, hands-off": "$34k more in 15 years, hands-off",
    "14 months sooner with Ed": "14 months sooner with Ed",
    "2 years sooner with Ed": "2 years sooner with Ed",
    "4 years sooner with Ed": "4 years sooner with Ed",
    "5 months longer with Ed": "5 months longer with Ed",
    "5 years sooner with Ed": "5 years sooner with Ed",
    "A simple shift that quietly hands you back money.": "A simple shift that quietly hands you back money.",
    "A tax move you're missing": "A tax move you're missing",
    "About how much do you earn?": "About how much do you earn?",
    "and about $4,200 less interest": "and about $4,200 less interest",
    "And how much goes out a month?": "And how much goes out a month?",
    "And how to get the keys sooner": "And how to get the keys sooner",
    "And your role?": "And your role?",
    "Balanced": "Balanced",
    "Build my $1M plan": "Build my $1M plan",
    "Build my debt-free plan": "Build my debt-free plan",
    "Build my first $1M": "Build my first $1M",
    "Build my home plan": "Build my home plan",
    "Build my idlecash plan": "Build my idlecash plan",
    "Build my retirement plan": "Build my retirement plan",
    "Build my runway plan": "Build my runway plan",
    "Build your safety cushion": "Build your safety cushion",
    "Cash Yield": "Cash Yield",
    "Check my portfolio risk": "Check my portfolio risk",
    "Common guardrail: no single sector above %{var0}%": "Common guardrail: no single sector above %{var0}%",
    "Debt": "Debt",
    "Does my portfolio match the risk I said I can take?": "Does my portfolio match the risk I said I can take?",
    "Ed extends budget by $80k for a larger home": "Ed extends budget by $80k for a larger home",
    "Ed keeps your savings rate on track.": "Ed auto-invests your full surplus, puts your idle cash to work, and optimizes your mix for tax.",
    "Ed lifts your buying power without overstretching you.": "Ed lifts your buying power without overstretching you.",
    "Ed optimizes your payoff order for you.": "Ed refinances you to a lower rate and puts your full surplus toward the balance.",
    "Ed orders your money to bring the date forward.": "Ed orders your money to bring the date forward.",
    "Ed reminds you every payday": "Ed reminds you every payday",
    "Ed runs the moves for you, automatically.": "Ed puts your idle cash to work, helps you invest your full surplus, and keeps your mix tax-smart.",
    "Ed stages the mix so one name cannot run the book.": "Ed stages the mix so one name cannot run the book.",
    "Financial Freedom": "Financial Freedom",
    "Fix my cash leak": "Fix my cash leak",
    "Get my money earning more": "Get my money earning more",
    "Go for growth": "Go for growth",
    "Good — now the basics.": "Good — now the basics.",
    "Got the top line. Now what goes out — roughly.": "Got the top line. Now what goes out — roughly.",
    "Have Ed track this": "Have Ed track this",
    "Have Ed track this now": "Have Ed track this now",
    "He frees up idle cash and builds your buffer, automatically.": "Ed frees up your idle cash and tops up your safety buffer automatically until you're covered.",
    "Here's your result": "Here's your result",
    "Home": "Home",
    "How far am I from a down payment?": "How far am I from a down payment?",
    "How fast you could be debt-free": "How fast you could be debt-free",
    "How long could I last with no income?": "How long could I last with no income?",
    "How long could you last with no income?": "How long could you last with no income?",
    "How long until I hit my first $1M, for real?": "How long until I hit my first $1M, for real?",
    "How many months could I last if income stopped?": "How many months could I last if income stopped?",
    "How much have you got invested?": "How much have you got invested?",
    "How much house can I really afford?": "How much house can I really afford?",
    "How much is my debt really costing me each month?": "How much is my debt really costing me each month?",
    "How much more could my idle cash earn?": "How much more could my idle cash earn?",
    "How much of my cash is just sitting there?": "How much of my cash is just sitting there?",
    "How old are you?": "How old are you?",
    "How risky is my portfolio right now?": "How risky is my portfolio right now?",
    "I'm Ed — your money person.": "I'm Ed — your money person.",
    "If income stopped today, here's how long.": "If income stopped today, here's how long.",
    "Invest": "Invest",
    "invested": "invested",
    "Is my emergency fund actually enough?": "Is my emergency fund actually enough?",
    "Is one stock running too much of my portfolio?": "Is one stock running too much of my portfolio?",
    "Last piece — what's already invested and working for you.": "Last piece — what's already invested and working for you.",
    "Lock a sharper mortgage rate": "Lock a sharper mortgage rate",
    "Make work optional sooner": "Make work optional sooner",
    "Maps each bucket, then checks it held next month.": "Maps each bucket, then checks it held next month.",
    "Most people never work this out.": "Most people never work this out.",
    "Now the other side of the ledger — no judgment, it helps me plan.": "Now the other side of the ledger — no judgment, it helps me plan.",
    "Now the specific role. Not listed? Pick the closest.": "Now the specific role. Not listed? Pick the closest.",
    "Now, what do you do? Start broad — the exact role comes next.": "Now, what do you do? Start broad — the exact role comes next.",
    "On your current pace, here's the age": "On your current pace, here's the age",
    "On your current pace, here's the year.": "On your current pace, here's the year.",
    "On your current pace, you're clear by": "On your current pace, you're clear by",
    "On your numbers today, here's your ceiling.": "On your numbers today, here's your ceiling.",
    "Out from under it, for good": "Out from under it, for good",
    "Peace of mind": "Peace of mind",
    "Plan my way out of debt": "Plan my way out of debt",
    "Play it safe": "Play it safe",
    "Put lazy money to work": "Put lazy money to work",
    "Put your idle cash to work": "Put your idle cash to work",
    "Rebalance to reach $1M sooner": "Rebalance to reach $1M sooner",
    "Round numbers are fine — I'll sharpen them as I get to know you.": "Round numbers are fine — I'll sharpen them as I get to know you.",
    "Same holdings, less riding on one.": "Same holdings, less riding on one.",
    "Same income, faster line.": "Same income, faster line.",
    "Same life, more kept.": "Same life, more kept.",
    "Same money each month — just in the right order, with your rate watched.": "Same money each month — just in the right order, with your rate watched.",
    "Same money, same access — just not in a 0.5% account.": "Same money, same access — just not in a 0.5% account.",
    "Same money, same access.": "Same money, same access.",
    "Same payment, faster out.": "Same payment, faster out.",
    "Sector Diversification": "Sector Diversification",
    "See what home I can afford": "See what home I can afford",
    "Shift your mix so the milestone arrives years earlier.": "Shift your mix so the milestone arrives years earlier.",
    "Six months of breathing room, set on autopilot.": "Six months of breathing room, set on autopilot.",
    "Spending": "Spending",
    "Spread so one name can't decide your year. Past drawdowns, not a forecast.": "Spread so one name can't decide your year. Past drawdowns, not a forecast.",
    "Spread so one sector can't decide your year.": "Spread so one sector can't decide your year.",
    "Spread the risk without pausing the plan": "Spread the risk without pausing the plan",
    "that's $1,000,000 — around age 57.": "that's $1,000,000 — around age 57.",
    "that's $1,260 per month": "that's $1,260 per month",
    "that's $1,600 every month": "that's $1,600 every month",
    "that's $2.1M. About 25x what you spend in a year": "that's $2.1M. About 25x what you spend in a year",
    "that's about $13,000 in the bank — gone by October.": "that's about $13,000 in the bank — gone by October.",
    "that's work-optional — about 14 years from now.": "that's work-optional — about 14 years from now.",
    "that's your last payment — about 6 years out.": "that's your last payment — about 6 years out.",
    "That's your whole money picture, %{var0}. One last thing — about you, not your accounts.": "That's your whole money picture, %{var0}. One last thing — about you, not your accounts.",
    "the common guardrail is 15%": "the common guardrail is 15%",
    "The cushion that lets you walk away": "The cushion that lets you walk away",
    "The seven-figure milestone": "The seven-figure milestone",
    "To get this right I just need one number: your everyday cash, sitting in checking and savings. Just drag.": "To get this right I just need one number: your everyday cash, sitting in checking and savings. Just drag.",
    "total": "total",
    "Wealth": "Wealth",
    "What am I actually spending each month?": "What am I actually spending each month?",
    "What do you owe?": "What do you owe?",
    "What home could I afford?": "What home could I afford?",
    "What home could you afford?": "What home could you afford?",
    "What is my idle cash costing me this year?": "What is my idle cash costing me this year?",
    "What should I call you?": "What should I call you?",
    "What you could earn in 15 years": "What you could earn in 15 years",
    "What you could save yearly": "What you could save yearly",
    "What's in the bank?": "What's in the bank?",
    "What's your style with money?": "What's your style with money?",
    "When can I stop working for money?": "When can I stop working for money?",
    "When can you stop working for money?": "When can you stop working for money?",
    "When the paycheck stops mattering": "When the paycheck stops mattering",
    "When will I be debt-free?": "When will I be debt-free?",
    "When will I hit my first $1M?": "When will I hit my first $1M?",
    "When will I really be debt-free?": "When will I really be debt-free?",
    "When will you be debt-free?": "When will you be debt-free?",
    "When will you hit your first $1M?": "When will you hit your first $1M?",
    "When work becomes optional": "When work becomes optional",
    "When work is a choice.": "When work is a choice.",
    "Which best describes your work?": "Which best describes your work?",
    "Which recurring charges are quietly draining me?": "Which recurring charges are quietly draining me?",
    "with your ~$84,000 deposit and current income.": "with your ~$84,000 deposit and current income.",
    "years old": "years old",
    "You'll hit your $1M!": "You'll hit your $1M!",
    "You're closer than it feels.": "You're closer than it feels.",
    "You’ve seen your Financial Fitness. Now — the thing you came in worried about.": "You’ve seen your Financial Fitness. Now — the thing you came in worried about.",
    "Your biggest holding": "Your biggest holding",
    "Your cash can work harder.": "Your cash can work harder.",
    "Your cash is barely working today.": "Your cash is barely working today.",
    "Your portfolio can steady out.": "Your portfolio can steady out.",
    "Your refinance window is open right now.": "Your refinance window is open right now.",
    "Your spending has room.": "Your spending has room."
  },
  "zh-tw": {
    "/ month": "/ 月",
    "/ year": "/年",
    "≈$40k sitting idle → a 4.5% position.": "≈$40k 閒置中 → 轉為 4.5% 部位。",
    "$31,000 less lost in a 2022-style drop": "若遇類似 2022 年大跌，可少虧 $31,000",
    "$34k more in 15 years, hands-off": "15 年後多賺 $34k，全自動打理",
    "14 months sooner with Ed": "搭配 Ed 提早 14 個月",
    "2 years sooner with Ed": "搭配 Ed 提早 2 年達成",
    "4 years sooner with Ed": "搭配 Ed 提早 4 年達成",
    "5 months longer with Ed": "搭配 Ed 多撐 5 個月",
    "5 years sooner with Ed": "搭配 Ed 提早 5 年達成",
    "A simple shift that quietly hands you back money.": "簡單調整，默默為你帶回收益。",
    "A tax move you're missing": "你可能錯過的節稅策略",
    "About how much do you earn?": "你的收入大約是多少？",
    "and about $4,200 less interest": "且利息將少約 4,200 美元",
    "And how much goes out a month?": "每月支出多少？",
    "And how to get the keys sooner": "以及如何更快拿到鑰匙",
    "And your role?": "那你的職位呢？",
    "Balanced": "平衡",
    "Build my $1M plan": "建立我的 $1M 計畫",
    "Build my debt-free plan": "建立我的無債計畫",
    "Build my first $1M": "建立我的第一個 $1M",
    "Build my home plan": "建立我的購屋計畫",
    "Build my idlecash plan": "建立我的閒置資金計畫",
    "Build my retirement plan": "建立我的退休計畫",
    "Build my runway plan": "建立我的資金跑道計畫",
    "Build your safety cushion": "建立你的安全網",
    "Cash Yield": "現金收益率",
    "Check my portfolio risk": "檢視我的組合風險",
    "Common guardrail: no single sector above %{var0}%": "常見防護機制：單一產業占比不超過 %{var0}%",
    "Debt": "債務",
    "Does my portfolio match the risk I said I can take?": "我的投資組合符合我說過能承受的風險嗎？",
    "Ed extends budget by $80k for a larger home": "Ed 為購置更大住宅，將預算調增 $80k",
    "Ed keeps your savings rate on track.": "Ed 自動幫你把每月結餘全數投入、讓閒置現金動起來，還把配置調到最省稅。",
    "Ed lifts your buying power without overstretching you.": "Ed 提升你的購買力，且不致過度擴張。",
    "Ed optimizes your payoff order for you.": "Ed 幫你把利率再融資到更低，再把每月結餘全部拿去還本金。",
    "Ed orders your money to bring the date forward.": "Ed 將為你重新配置資金，以提前目標日期。",
    "Ed reminds you every payday": "Ed 會在每個發薪日提醒你。",
    "Ed runs the moves for you, automatically.": "Ed 讓你的閒置現金動起來、幫你把每月結餘全部投出去，還把配置維持在最省稅。",
    "Ed stages the mix so one name cannot run the book.": "Ed 已調整組合配置，確保單一標的不致主導整體投資組合。",
    "Financial Freedom": "財務自由",
    "Fix my cash leak": "改善現金流失",
    "Get my money earning more": "讓資金創造更高報酬",
    "Go for growth": "追求成長",
    "Good — now the basics.": "好的 — 接下來是基礎設定。",
    "Got the top line. Now what goes out — roughly.": "收入有了。那大概花多少？",
    "Have Ed track this": "讓 Ed 追蹤",
    "Have Ed track this now": "立即由 Ed 追蹤",
    "He frees up idle cash and builds your buffer, automatically.": "Ed 幫你釋出閒置現金，自動補滿你的安全網，直到足夠為止。",
    "Here's your result": "你的結果如下",
    "Home": "首頁",
    "How far am I from a down payment?": "我離頭期款還差多少？",
    "How fast you could be debt-free": "多快能實現無債",
    "How long could I last with no income?": "若沒有收入，我能撐多久？",
    "How long could you last with no income?": "如果你沒有收入，你能撐多久？",
    "How long until I hit my first $1M, for real?": "實際算下來，我還要多久才能達成第一個 100 萬美元？",
    "How many months could I last if income stopped?": "如果收入中斷，我能撐幾個月？",
    "How much have you got invested?": "你目前投資了多少？",
    "How much house can I really afford?": "我實際上買得起多少價位的房子？",
    "How much is my debt really costing me each month?": "我的債務每個月實際讓我付出多少？",
    "How much more could my idle cash earn?": "我的閒置資金還能多賺多少？",
    "How much of my cash is just sitting there?": "我有多少現金只是閒置在那裡？",
    "How old are you?": "你幾歲？",
    "How risky is my portfolio right now?": "我的投資組合現在風險有多高？",
    "I'm Ed — your money person.": "我是 Ed — 你的私人理財官。",
    "If income stopped today, here's how long.": "若今日收入中斷，你的資產可支撐多久？",
    "Invest": "投資",
    "invested": "已投資",
    "Is my emergency fund actually enough?": "我的緊急預備金真的夠嗎？",
    "Is one stock running too much of my portfolio?": "我的投資組合是不是過度集中在單一股票？",
    "Last piece — what's already invested and working for you.": "最後一項 — 你目前已持有且正在運作的投資。",
    "Lock a sharper mortgage rate": "鎖定更優惠的房貸利率",
    "Make work optional sooner": "早日讓工作成為選擇",
    "Maps each bucket, then checks it held next month.": "幫你把每一筆歸好類，下個月再檢查有沒有守住。",
    "Most people never work this out.": "多數人難以自行計算。",
    "Now the other side of the ledger — no judgment, it helps me plan.": "現在看帳本的另一邊——不帶評判，這能幫我做規劃。",
    "Now the specific role. Not listed? Pick the closest.": "接著選具體職位。沒列出來？挑最接近的。",
    "Now, what do you do? Start broad — the exact role comes next.": "你是做什麼的？先選大方向，下一屏再挑具體職位。",
    "On your current pace, here's the age": "以你目前的進度，這是你的年齡",
    "On your current pace, here's the year.": "照你現在的節奏，就是這一年。",
    "On your current pace, you're clear by": "以你目前的進度，預計可於",
    "On your numbers today, here's your ceiling.": "根據你今日的資料，這是你的預估上限。",
    "Out from under it, for good": "徹底擺脫，一勞永逸",
    "Peace of mind": "安心",
    "Plan my way out of debt": "制定還債計畫",
    "Play it safe": "穩健操作",
    "Put lazy money to work": "活化閒置資金",
    "Put your idle cash to work": "讓閒置資金為你工作",
    "Rebalance to reach $1M sooner": "再平衡以更快達成 $1M 目標",
    "Round numbers are fine — I'll sharpen them as I get to know you.": "先輸入整數即可，待我熟悉你的需求後，會再為你精確調整。",
    "Same holdings, less riding on one.": "持倉不變，降低單一依賴。",
    "Same income, faster line.": "收入不變，更快達標。",
    "Same life, more kept.": "生活不變，留存更多。",
    "Same money each month — just in the right order, with your rate watched.": "每月投入相同金額，僅需依正確順序配置，並持續為你追蹤報酬率。",
    "Same money, same access — just not in a 0.5% account.": "一樣的錢、一樣隨時能動用，只是不放在利率 0.5% 的帳戶裡。",
    "Same money, same access.": "一樣的錢，一樣隨時動用。",
    "Same payment, faster out.": "還款金額不變，更快還清。",
    "Sector Diversification": "產業分散",
    "See what home I can afford": "查看我能負擔的房屋",
    "Shift your mix so the milestone arrives years earlier.": "調整你的配置，讓目標提前數年達成。",
    "Six months of breathing room, set on autopilot.": "六個月緩衝期，自動執行。",
    "Spending": "支出",
    "Spread so one name can't decide your year. Past drawdowns, not a forecast.": "分散配置，避免單一標的左右你的全年績效。僅為歷史回撤資料，非績效預測。",
    "Spread so one sector can't decide your year.": "分散配置，避免單一產業左右你全年的績效。",
    "Spread the risk without pausing the plan": "分散風險，同時持續執行計畫",
    "that's $1,000,000 — around age 57.": "那就是 100 萬美元——大約在 57 歲。",
    "that's $1,260 per month": "相當於每月 $1,260",
    "that's $1,600 every month": "也就是每月 $1,600。",
    "that's $2.1M. About 25x what you spend in a year": "那就是 $2.1M。約為你一年支出的 25 倍。",
    "that's about $13,000 in the bank — gone by October.": "帳上約有 13,000 美元，到十月便會化為烏有。",
    "that's work-optional — about 14 years from now.": "這代表可選擇不工作——大約在 14 年後。",
    "that's your last payment — about 6 years out.": "這是你的最後一筆款項 — 約在 6 年後。",
    "That's your whole money picture, %{var0}. One last thing — about you, not your accounts.": "這就是你的完整資產全貌，%{var0}。最後一件事——關於你本人，而非你的帳戶。",
    "the common guardrail is 15%": "常見的安全邊界為 15%",
    "The cushion that lets you walk away": "讓你安心離場的緩衝",
    "The seven-figure milestone": "七位數里程碑",
    "To get this right I just need one number: your everyday cash, sitting in checking and savings. Just drag.": "為精準掌握，我只需要一個數字：你日常存放於支票與儲蓄帳戶的現金。只需拖曳即可。",
    "total": "總計",
    "Wealth": "財富",
    "What am I actually spending each month?": "我每個月實際花了多少錢？",
    "What do you owe?": "你欠多少？",
    "What home could I afford?": "我能負擔得起什麼樣的房子？",
    "What home could you afford?": "你買得起什麼樣的房？",
    "What is my idle cash costing me this year?": "我的閒置資金今年讓我少賺了多少？",
    "What should I call you?": "我該怎麼稱呼你？",
    "What you could earn in 15 years": "15 年預期收益",
    "What you could save yearly": "每年可儲存的金額",
    "What's in the bank?": "帳戶餘額為何？",
    "What's your style with money?": "你的理財風格是？",
    "When can I stop working for money?": "我什麼時候可以不用再為錢工作？",
    "When can you stop working for money?": "你何時能不再為薪水工作？",
    "When the paycheck stops mattering": "當薪水不再重要時",
    "When will I be debt-free?": "我何時能擺脫債務？",
    "When will I hit my first $1M?": "我何時能達成第一個 100 萬美元？",
    "When will I really be debt-free?": "我究竟何時才能擺脫債務？",
    "When will you be debt-free?": "你預計何時能清償所有債務？",
    "When will you hit your first $1M?": "你預計何時達成一百萬美元目標？",
    "When work becomes optional": "當工作成為可選項",
    "When work is a choice.": "當工作成為一種選擇。",
    "Which best describes your work?": "哪一個最接近你的工作？",
    "Which recurring charges are quietly draining me?": "哪些定期扣款正在悄悄吃掉我的錢？",
    "with your ~$84,000 deposit and current income.": "搭配你的 $84,000 存款與目前收入。",
    "years old": "歲",
    "You'll hit your $1M!": "即將達成 $1M 目標！",
    "You're closer than it feels.": "你比感覺中更接近目標。",
    "You’ve seen your Financial Fitness. Now — the thing you came in worried about.": "你已查看財務健康度。現在，來處理你當初最擔心的問題。",
    "Your biggest holding": "最大持股",
    "Your cash can work harder.": "讓你的資金發揮更大效益。",
    "Your cash is barely working today.": "你的現金目前幾乎沒在生錢。",
    "Your portfolio can steady out.": "你的投資組合有望逐步穩定。",
    "Your refinance window is open right now.": "你的再融資窗口目前已開啟。",
    "Your spending has room.": "你的支出尚有餘裕。"
  }
};

export default translations;
